<template>
	<div>
		<!-- 面包屑导航区域 -->		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 -->
			<div style="margin-bottom: 20px;">
				<el-form ref="memberPremoneyPageInfoReq" :model="memberPremoneyPageInfoReq" label-width="80px" inline
					size="small">
					<el-form-item label="运营商:" v-if="isAdmin">
						<el-select v-model="memberPremoneyPageInfoReq.distributorId" placeholder="请选择" clearable filterable
							style="width: 150px;">
							<el-option v-for="item in distributorOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="手机号:">
						<el-input :clearable=true v-model="memberPremoneyPageInfoReq.memberMobile" placeholder="请输入手机号"
							style="width: 150px;" />
					</el-form-item>
					<el-form-item label="车锁编号:">
						<el-input :clearable=true v-model="memberPremoneyPageInfoReq.qrNumber" placeholder="请输入车锁编号"
							style="width: 150px;" />
					</el-form-item>
					<el-form-item label="状态:">
						<el-select v-model="memberPremoneyPageInfoReq.status" placeholder="请选择" clearable
							style="width: 120px;">
							<el-option v-for="item in statusOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="类型:">
						<el-select v-model="memberPremoneyPageInfoReq.rechargeType" placeholder="请选择" clearable
							style="width: 120px;">
							<el-option label="押金充值" :value="1"></el-option>
							<el-option label="卡券购买" :value="4"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建时间:">
						<el-date-picker v-model="dateRange" type="daterange" range-separator="-"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd" @change="handleDateChange">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="reGetMemberPremoneyList()">查询</el-button>
						<el-button type="success" @click="showBillSummaryDialog">账单汇总</el-button>
					</el-form-item>
				</el-form>
			</div>
			<!-- 押金列表区域 -->
			<el-table :data="memberPremoneyList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column type="index"></el-table-column>
				<el-table-column label="手机号" prop="memberMobile"></el-table-column>
				<el-table-column label="车锁编号" prop="qrNumber"></el-table-column>
				<el-table-column label="类型" width="100px">
					<template slot-scope="scope">
						<el-tag :type="scope.row.rechargeType == 4 ? 'warning' : ''" size="small">
							{{ scope.row.rechargeType == 4 ? '卡券购买' : '押金充值' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="押金金额" prop="preMoney">
					<template slot-scope="scope">
						<span style="color: #67C23A; font-weight: bold;">¥{{ scope.row.preMoney }}</span>
					</template>
				</el-table-column>
				<el-table-column label="消费金额" prop="costMoney">
					<template slot-scope="scope">
						<span style="color: #E6A23C; font-weight: bold;">¥{{ scope.row.costMoney }}</span>
					</template>
				</el-table-column>
				<el-table-column label="已退款金额" prop="backMoney">
					<template slot-scope="scope">
						<span style="color: #F56C6C; font-weight: bold;">¥{{ scope.row.backMoney }}</span>
					</template>
				</el-table-column>
				<el-table-column label="创建时间" prop="createTime" width="150px"></el-table-column>
				<el-table-column label="更新时间" prop="updateTime" width="150px"></el-table-column>
				<el-table-column label="运营商" prop="distributorId">
					<template slot-scope="scope">
						{{ getDistributorName(scope.row.distributorId) }}
					</template>
				</el-table-column>
				<el-table-column label="状态" prop="status" width="120px">
					<template slot-scope="scope">
						<el-tag
							:type="scope.row.status === 0 ? 'success' : (scope.row.status === 1 ? 'primary' : (scope.row.status === 2 ? 'warning' : (scope.row.status === 3 ? 'success' : (scope.row.status === 4 ? 'danger' : 'info'))))">
							{{ getStatusDesc(scope.row.status) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column fixed="right" header-align="center" align="center" width="150px" label="操作">
					<template slot-scope="scope">
						<el-button
							size="mini" type="warning"
							@click="backMoney(scope.row.id, scope.row.memberMobile)">退款</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="memberPremoneyPageInfoReq.page" :page-sizes="[8, 15, 25, 50, 100]"
				:page-size="memberPremoneyPageInfoReq.limit" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>

			<!-- 退款对话框 -->
			<el-dialog title="押金退款" :visible.sync="backMoneyDialogVisible" width="500px">
				<el-form :model="backMoneyForm" label-width="100px">
					<el-form-item label="手机号:">
						<el-input v-model="backMoneyForm.memberMobile" disabled></el-input>
					</el-form-item>
					<el-form-item label="退款金额:">
						<el-input v-model="backMoneyForm.backMoney">
							<template slot="prepend">¥</template>
						</el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="backMoneyDialogVisible = false">取 消</el-button>
					<el-button type="warning" @click="confirmBackMoney">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 账单汇总对话框 -->
			<el-dialog title="微信支付账单汇总" :visible.sync="billSummaryDialogVisible" width="1200px" @close="closeBillSummaryDialog">
				<div style="margin-bottom: 15px;">
					<el-form :model="billSummaryForm" label-width="80px" inline size="small">
						<el-form-item label="日期范围:">
							<el-date-picker v-model="billSummaryForm.dateRange" type="daterange" range-separator="-"
								start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
								value-format="yyyy-MM-dd" style="width: 280px;">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="子商户号:" v-if="isAdmin">
							<el-select v-model="billSummaryForm.subMchid" placeholder="请选择商户" clearable filterable style="width: 220px;">
								<el-option v-for="item in merchantConfigList" :key="item.mchId" :label="item.mchId + ' - ' + item.distributorName" :value="item.mchId"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="loadBillSummary" :loading="billSummaryLoading" style="min-width: 72px;">查询</el-button>
							<el-button type="warning" @click="syncBillSummary" :loading="syncBillLoading" style="min-width: 88px;">同步账单</el-button>
							<el-button type="success" @click="downloadBillCsv" :loading="downloadBillLoading" style="min-width: 88px;">下载明细</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-table :data="billSummaryList" border stripe size="small" max-height="450" :header-cell-style="{ textAlign: 'center' }"
					:cell-style="{ textAlign: 'center' }" show-summary :summary-method="getBillSummaryTotal" v-loading="billSummaryLoading">
					<el-table-column label="日期" prop="billDate" width="100px">
						<template slot-scope="scope">
							{{ formatDate(scope.row.billDate) }}
						</template>
					</el-table-column>
					<el-table-column label="特约商户号" prop="subMchid" width="120px" show-overflow-tooltip></el-table-column>
					<el-table-column label="总交易笔数" prop="totalCount" width="90px"></el-table-column>
					<el-table-column label="支付笔数" prop="payCount" width="80px"></el-table-column>
					<el-table-column label="退款笔数" prop="refundCount" width="80px"></el-table-column>
					<el-table-column label="应结订单金额" prop="settledAmount" width="110px">
						<template slot-scope="scope">
							<span style="color: #67C23A; font-weight: bold;">¥{{ scope.row.settledAmount }}</span>
						</template>
					</el-table-column>
					<el-table-column label="退款总金额" prop="refundAmount" width="100px">
						<template slot-scope="scope">
							<span style="color: #F56C6C; font-weight: bold;">¥{{ scope.row.refundAmount }}</span>
						</template>
					</el-table-column>
					<el-table-column label="净收入" prop="netAmount" width="100px">
						<template slot-scope="scope">
							<span style="color: #409EFF; font-weight: bold;">¥{{ scope.row.netAmount }}</span>
						</template>
					</el-table-column>
					<el-table-column label="手续费(净)" prop="feeAmount" width="100px">
						<template slot-scope="scope">
							<span>¥{{ scope.row.feeAmount }}</span>
						</template>
					</el-table-column>
					<el-table-column label="支付手续费" prop="payFee" width="100px">
						<template slot-scope="scope">
							<span>¥{{ scope.row.payFee }}</span>
						</template>
					</el-table-column>
					<el-table-column label="退款费返还" prop="refundFeeReversal" width="100px">
						<template slot-scope="scope">
							<span>¥{{ scope.row.refundFeeReversal }}</span>
						</template>
					</el-table-column>
					<el-table-column label="实际到账" prop="actualAmount" width="100px">
						<template slot-scope="scope">
							<span style="color: #E6A23C; font-weight: bold;">¥{{ scope.row.actualAmount }}</span>
						</template>
					</el-table-column>
					<el-table-column label="订单总金额" prop="orderAmount" width="100px"></el-table-column>
					<el-table-column label="申请退款总额" prop="refundRequestAmount" width="110px"></el-table-column>
					<el-table-column label="充值券退款" prop="couponRefundAmount" width="100px"></el-table-column>
				</el-table>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
	data() {
		return {
			user: '',
			isAdmin: false,
			dateRange: [],
			distributorOptions: [],
			distributorInfoList: [], // 存储完整的运营商信息
			statusOptions: [{
				key: 0,
				value: '已退款'
			}, {
				key: 1,
				value: '未退款'
			}, {
				key: 2,
				value: '已消费'
			}, {
				key: 3,
				value: '消费已退款'
			}, {
				key: 4,
				value: '消费未退款'
			}, {
				key: 5,
				value: '执行退款中'
			}],
			memberPremoneyPageInfoReq: {
				//当前页数
				page: 1,
				//当前每页多少条
				limit: 8,
				memberId: '',
				memberMobile: '',
				status: '',
				rechargeType: '',
				distributorId: '',
				startDate: '',
				endDate: '',
				qrNumber: '',
				queryDistributorId: ''
			},
			memberPremoneyList: [],
			total: 0,
			backMoneyDialogVisible: false,
			// 批量操作相关数据
			multipleSelection: [],
			memberPremoneyInfo: {},
			backMoneyForm: {
				id: '',
				memberId: '',
				preMoney: '',
				reason: ''
			},
			billSummaryDialogVisible: false,
			billSummaryLoading: false,
			syncBillLoading: false,
			downloadBillLoading: false,
			billSummaryList: [],
			merchantConfigList: [],
			billSummaryForm: {
				dateRange: [],
				subMchid: ''
			},
		}
	},
	created() {
		this.user = window.sessionStorage.getItem('user');
		this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true';
		this.getDistributorOptions();
		this.memberPremoneyPageInfoReq.queryDistributorId = getCurrentDistributorId()
		this.getMemberPremoneyList();
		// 监听运营商切换事件
		this.$root.$on('distributorChanged', this.handleDistributorChange)
	},
	beforeDestroy() {
		// 移除事件监听
		this.$root.$off('distributorChanged', this.handleDistributorChange)
	},
	methods: {
		handleDistributorChange(distributorId) {
			this.memberPremoneyPageInfoReq.queryDistributorId = distributorId || ''
			this.memberPremoneyPageInfoReq.page = 1
			this.getMemberPremoneyList()
		},
		async getMemberPremoneyList() {
			const { data: res } = await this.$http.post(
				'/member/premoney/getMemberPremoneyPageInfo', this.memberPremoneyPageInfoReq)
			if (res.code != 200) return this.$message.error(res.msg)
			this.memberPremoneyList = res.data.list
			this.total = res.data.total
		},
		reGetMemberPremoneyList() {
			this.memberPremoneyPageInfoReq.page = 1;
			this.getMemberPremoneyList();
		},
		// 获取运营商选项
		getDistributorOptions() {
			this.$http.get('/distributor/manager/getAllDistributorInfo').then((res) => {
				this.distributorOptions = [];
				this.distributorInfoList = []; // 清空并重新赋值
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				let distributorInfoList = res.data.data;
				for (let index in distributorInfoList) {
					this.distributorOptions.push({ key: distributorInfoList[index].id, value: distributorInfoList[index].name });
				}
				// 保存完整的运营商信息
				this.distributorInfoList = distributorInfoList;
			});
		},
		// 处理日期范围变化
		handleDateChange(val) {
			if (val) {
				this.memberPremoneyPageInfoReq.startDate = val[0];
				this.memberPremoneyPageInfoReq.endDate = val[1];
			} else {
				this.memberPremoneyPageInfoReq.startDate = '';
				this.memberPremoneyPageInfoReq.endDate = '';
			}
		},
		//监听pagesize变化
		handleSizeChange(pageSize) {
			this.memberPremoneyPageInfoReq.limit = pageSize
			this.getMemberPremoneyList()
		},
		//监听页数变化
		handleCurrentChange(pageNum) {
			this.memberPremoneyPageInfoReq.page = pageNum
			this.getMemberPremoneyList()
		},
		// 退款操作
		backMoney(id, memberMobile) {
			// 获取押金详情
			this.$http.get('/member/premoney/getMemberPremoneyById/' + id).then((res) => {
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				const data = res.data;
				this.backMoneyForm = {
					id: id,
					memberMobile: memberMobile,
					backMoney: data.preMoney,
					reason: ''
				};
				this.backMoneyDialogVisible = true;
			});
		},
		// 确认退款
		confirmBackMoney() {
			this.$confirm('确认退款 ¥' + this.backMoneyForm.backMoney + ' 吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post('/member/premoney/backMoneyWithAmount', {
					id: this.backMoneyForm.id,
					type: 1, // 默认类型为1
					refundAmount: this.backMoneyForm.backMoney
				}).then((res) => {
					if (res.data.code != 200) return this.$message.error(res.data.msg);
					this.backMoneyDialogVisible = false;
					this.reGetMemberPremoneyList();
					this.$message.success(res.data.msg);
				})
			}).catch(() => {
				this.$message.info('已取消退款');
			});
		},
		// 监听多选框变化
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 获取状态描述
		getStatusDesc(status) {
			switch (status) {
				case 0:
					return '已退款';
				case 1:
					return '未退款';
				case 2:
					return '已消费';
				case 3:
					return '消费已退款';
				case 4:
					return '消费未退款';
				case 5:
					return '执行退款中';
				default:
					return '未知状态';
			}
		},
		// 根据ID获取运营商名称
		getDistributorName(distributorId) {
			if (!distributorId) return '未知';
			const distributor = this.distributorInfoList.find(item => item.id === distributorId);
			return distributor ? distributor.name : '未知';
		},
		showBillSummaryDialog() {
			var today = new Date();
			var yyyy = today.getFullYear();
			var MM = String(today.getMonth() + 1).padStart(2, '0');
			var dd = String(today.getDate()).padStart(2, '0');
			var todayStr = yyyy + '-' + MM + '-' + dd;
			this.billSummaryForm = {
				dateRange: [todayStr, todayStr],
				subMchid: ''
			};
			this.billSummaryList = [];
			this.billSummaryDialogVisible = true;
			if (this.isAdmin && this.merchantConfigList.length === 0) {
				this.loadMerchantConfigList();
			}
			this.$nextTick(() => {
				this.loadBillSummary();
			});
		},
		closeBillSummaryDialog() {
			this.billSummaryList = [];
		},
		loadMerchantConfigList() {
			this.$http.get('/merchant/payment/config/all').then((res) => {
				if (res.data.code === 200) {
					this.merchantConfigList = res.data.data || [];
				}
			}).catch(() => {});
		},
		loadBillSummary() {
			if (!this.billSummaryForm.dateRange || this.billSummaryForm.dateRange.length !== 2) {
				return this.$message.warning('请选择日期范围');
			}
			this.billSummaryLoading = true;
			var params = {
				startDate: this.billSummaryForm.dateRange[0],
				endDate: this.billSummaryForm.dateRange[1]
			};
			if (this.isAdmin && this.billSummaryForm.subMchid) {
				params.subMchid = this.billSummaryForm.subMchid;
			}
			if (!this.isAdmin) {
				var currentDistributorId = getCurrentDistributorId();
				if (currentDistributorId) {
					params.distributorId = currentDistributorId;
				} else if (this.memberPremoneyPageInfoReq.distributorId) {
					params.distributorId = this.memberPremoneyPageInfoReq.distributorId;
				}
			}
			this.$http.get('/member/premoney/getBillSummaryList', { params: params }).then((res) => {
				this.billSummaryLoading = false;
				if (res.data.code !== 200) {
					this.$message.error(res.data.msg || '查询失败');
					return;
				}
				this.billSummaryList = res.data.data || [];
			}).catch(() => {
				this.billSummaryLoading = false;
				this.$message.error('查询账单汇总失败');
			});
		},
		syncBillSummary() {
			if (!this.billSummaryForm.dateRange || this.billSummaryForm.dateRange.length !== 2) {
				return this.$message.warning('请选择日期范围');
			}
			this.$confirm('将从微信服务器同步账单数据并覆盖已有汇总，是否继续？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.syncBillLoading = true;
				var params = {
					startDate: this.billSummaryForm.dateRange[0],
					endDate: this.billSummaryForm.dateRange[1]
				};
				if (this.isAdmin && this.billSummaryForm.subMchid) {
					params.subMchid = this.billSummaryForm.subMchid;
				}
				if (!this.isAdmin) {
					var currentDistributorId = getCurrentDistributorId();
					if (currentDistributorId) {
						params.distributorId = currentDistributorId;
					} else if (this.memberPremoneyPageInfoReq.distributorId) {
						params.distributorId = this.memberPremoneyPageInfoReq.distributorId;
					}
				}
				this.$http.get('/member/premoney/syncBillSummary', { params: params }).then((res) => {
					this.syncBillLoading = false;
					if (res.data.code !== 200) {
						this.$message.error(res.data.msg || '同步失败');
						return;
					}
					this.$message.success(res.data.data || '同步成功');
					this.loadBillSummary();
				}).catch(() => {
					this.syncBillLoading = false;
					this.$message.error('同步账单失败');
				});
			}).catch(() => {});
		},
		downloadBillCsv() {
			if (!this.billSummaryForm.dateRange || this.billSummaryForm.dateRange.length !== 2) {
				return this.$message.warning('请选择日期范围');
			}
			if (this.billSummaryList.length === 0) {
				return this.$message.warning('暂无汇总数据，请先同步账单');
			}
			this.downloadBillLoading = true;
			var params = new URLSearchParams();
			params.append('startDate', this.billSummaryForm.dateRange[0]);
			params.append('endDate', this.billSummaryForm.dateRange[1]);
			if (this.isAdmin && this.billSummaryForm.subMchid) {
				params.append('subMchid', this.billSummaryForm.subMchid);
			}
			if (!this.isAdmin) {
				var currentDistributorId = getCurrentDistributorId();
				if (currentDistributorId) {
					params.append('distributorId', currentDistributorId);
				} else if (this.memberPremoneyPageInfoReq.distributorId) {
					params.append('distributorId', this.memberPremoneyPageInfoReq.distributorId);
				}
			}
			this.$http.get('/member/premoney/exportBillSummary?' + params.toString(), {
				responseType: 'blob'
			}).then((res) => {
				const blob = new Blob([res.data], { type: 'application/octet-stream' });
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = 'bill_summary_' + this.billSummaryForm.dateRange[0] + '_to_' + this.billSummaryForm.dateRange[1] + '.csv';
				link.click();
				window.URL.revokeObjectURL(url);
				this.$message.success('下载成功');
			}).catch(() => {
				this.$message.error('下载失败，请稍后重试');
			}).finally(() => {
				this.downloadBillLoading = false;
			});
		},
		formatDate(dateStr) {
			if (!dateStr) return '';
			var d = new Date(dateStr);
			var yyyy = d.getFullYear();
			var MM = String(d.getMonth() + 1).padStart(2, '0');
			var dd = String(d.getDate()).padStart(2, '0');
			return yyyy + '-' + MM + '-' + dd;
		},
		getBillSummaryTotal(param) {
			const { columns, data } = param;
			const sums = [];
			const numberCols = ['totalCount', 'payCount', 'refundCount', 'settledAmount', 'refundAmount',
				'netAmount', 'feeAmount', 'payFee', 'refundFeeReversal', 'actualAmount',
				'orderAmount', 'refundRequestAmount', 'couponRefundAmount'];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = '合计';
					return;
				}
				if (numberCols.indexOf(column.property) > -1) {
					const values = data.map(item => Number(item[column.property]));
					if (!values.every(value => isNaN(value))) {
						var total = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + value;
							} else {
								return prev;
							}
						}, 0);
						if (['settledAmount', 'refundAmount', 'netAmount', 'feeAmount', 'payFee',
							'refundFeeReversal', 'actualAmount', 'orderAmount', 'refundRequestAmount', 'couponRefundAmount'].indexOf(column.property) > -1) {
							sums[index] = '¥' + total.toFixed(2);
						} else {
							sums[index] = total;
						}
					} else {
						sums[index] = '';
					}
				} else {
					sums[index] = '';
				}
			});
			return sums;
		},
	}
}
</script>

<style scoped>
.el-card {
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
}

.el-table {
	margin-top: 15px;
	font-size: 12px;
}

.el-pagination {
	margin-top: 15px;
}
</style>